import { Box, Button, ButtonBase, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Stack, TextField, Typography, Zoom, useMediaQuery } from '@mui/material';
import React, { useEffect, useLayoutEffect, useState } from 'react'
import styled from 'styled-components';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import ButtonStyled from '../../atoms/v2/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CheckoutErrorDialog = (props: ICheckoutErrorDialogProps) => {
    const { onClose, open, onReattempt } = props;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down(400));

    return (
        <BootstrapDialog
            open={open}
            fullWidth
            fullScreen={true}
            transitionDuration={0}
        >
            <DialogContent sx={{
                maxWidth: "400px",
                width: "100%",
                p: 2,
                boxSizing: "border-box",
                alignSelf: 'center'
            }}>
                <Stack spacing={5}>
                    <Stack spacing={3}>
                        <Typography
                            variant='h5'
                            textAlign='center'
                            fontWeight={500}
                            color='#f44336'>
                            Transacción fallida
                        </Typography>
                        <Typography
                            variant='body1'
                            textAlign='center'>
                            Intenta nuevamente. Si el problema continúa, comunícate con nosotros para una solución
                        </Typography>
                        <Stack spacing={1}>
                            <Typography
                                variant='subtitle1'
                                textAlign='left'
                                fontWeight={500}>
                                Número de contacto
                            </Typography>
                            <Typography
                                variant='body1'
                                textAlign='left'>
                                +51 975 400 190
                            </Typography>
                        </Stack>
                        <Stack spacing={1}>
                            <Typography
                                variant='subtitle1'
                                textAlign='left'
                                fontWeight={500}>
                                Correo de contacto
                            </Typography>
                            <Typography
                                variant='body1'
                                textAlign='left'>
                                RaDi-languages@t-online.de
                            </Typography>
                        </Stack>

                    </Stack>
                    <ButtonStyled onClick={onReattempt}>
                        Intentar nuevamente
                    </ButtonStyled>
                </Stack>
            </DialogContent>
        </BootstrapDialog>
    );
}

const BootstrapDialog = styled(Dialog)(() => ({
    '& .MuiDialog-paper': {
        borderRadius: 20,
        maxWidth: 350
    },

    '& .MuiDialog-paperFullScreen': {
        borderRadius: 0,
        maxWidth: '100%'
    }
}));

const IconButtonStyled = styled(IconButton)({
    '&.MuiIconButton-root': {
        borderRadius: 15,
        borderWidth: 1,
        borderColor: '#32b0ea',
        borderStyle: 'solid'
    }
})

export { CheckoutErrorDialog }